import { render } from "./AreaIncomeReport.vue?vue&type=template&id=94a05164&ts=true&lang=pug"
import script from "./AreaIncomeReport.vue?vue&type=script&lang=ts"
export * from "./AreaIncomeReport.vue?vue&type=script&lang=ts"

import "./AreaIncomeReport.vue?vue&type=style&index=0&id=94a05164&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__